module.exports = __webpack_public_path__ + "img/medical-tests.bc895a21.svg";